import React, { useEffect, useState } from "react";
import axios from "axios";
import Topbar from '../components/topbar'; 
import Sidebar from '../components/sidebar'; 
import Footer from '../components/footer'; 
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API_URL = `${BASE_URL}admin/getdata/get_gallerycategory.php`; // change path

const Gcategory = () => {
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const res = await axios.get(API_URL);
      setCategories(res.data);
    } catch (err) {
      console.error(err);
      setMessage("Error loading categories");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!categoryName.trim()) return;

    try {
      if (editingId === null) {
        // CREATE
        await axios.post(`${API_URL}?action=create`, { name: categoryName });
        setMessage("Category added");
      } else {
        // UPDATE
        await axios.post(`${API_URL}?action=update`, {
          id: editingId,
          name: categoryName,
        });
        setMessage("Category updated");
      }
      setCategoryName("");
      setEditingId(null);
      fetchCategories();
    } catch (err) {
      console.error(err);
      setMessage("Save failed");
    }
  };

  const handleEdit = (cat) => {
    setCategoryName(cat.name);
    setEditingId(cat.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this category?")) return;
    try {
      await axios.post(`${API_URL}?action=delete`, { id });
      setMessage("Category deleted");
      fetchCategories();
    } catch (err) {
      console.error(err);
      setMessage("Delete failed");
    }
  };

  return (
     <div class="header-light sidebar-dark sidebar-expand">
        <Topbar />
        <div class="content-wrapper">
        <Sidebar />  
         <main class="main-wrapper clearfix">
                  <div class="widget-list">

    
      <h4>Gallery Category</h4>

      {/* Add / Edit */}
      <div className="card mt-3">
        <div className="card-header">Add Category Name</div>
        <div className="card-body">
          {message && <div className="alert alert-info py-2">{message}</div>}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Category Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Category Name"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
              />
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {editingId === null ? "Submit" : "Update"}
            </button>
          </form>
        </div>
      </div>

      {/* List */}
      <div className="card mt-4">
        <div className="card-header">View Gallery Category</div>
        <div className="card-body p-0">
          {loading ? (
            <p className="p-3 mb-0">Loading...</p>
          ) : (
            <table className="table table-bordered mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Category Name</th>
                  <th style={{ width: "140px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {categories.length > 0 ? (
                  categories.map((cat, index) => (
                    <tr key={cat.id}>
                      <td>{index + 1}</td>
                      <td>{cat.name}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-secondary me-2"
                          onClick={() => handleEdit(cat)}
                        >
                          ✏️
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(cat.id)}
                        >
                          🗑
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No Categories Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
    
    </main>
     <Footer />
    </div>
    </div>
  );
};

export default Gcategory;
